let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cLJTa")).then(() => parcelRequire('4EFIZ'));